module.exports = __webpack_public_path__ + "img/head.2f75b9fa.png";